import { render, staticRenderFns } from "./childAchievement.vue?vue&type=template&id=71ea223f"
import script from "./childAchievement.vue?vue&type=script&lang=js"
export * from "./childAchievement.vue?vue&type=script&lang=js"
import style0 from "./childAchievement.vue?vue&type=style&index=0&id=71ea223f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports